export const HiroBasicApi = Symbol('HiroBasicApi');
